import React from "react"
import Input from "../../UI/input/Input"
import Button from "../../UI/button/Button"
import useShowPass from "../../custom_hooks/show-pass"
import useChangePass from "../../custom_hooks/use-changePass"
import * as Style from "../Form.module.scss"
import Icon from "../../../images/exclamation.svg"
import PassIcon from "../../../images/input-icons/pass.svg"
import VisIcon from "../../../images/input-icons/visibility.svg"
import VisIconOff from "../../../images/input-icons/visibilityoff.svg"
import CloseIcon from "../../../images/input-icons/close.svg"
import Loader from "../../UI/loader/Loader"

const ChangePass = ({ showHidePassWindow }) => {
  const {
    formHandler,
    inputHandler,
    resolveInputServerError,
    setNextStep,
    inputState,
    submit,
    error,
    nextStep,
    loading,
  } = useChangePass()

  const {
    showPassInputOneHandler,
    showPassInputTwoHandler,
    showPassInputThreeHandler,
    showPassOne,
    showPassTwo,
    showPassThree,
  } = useShowPass()

  const closeHandler = () => {
    showHidePassWindow()
    setNextStep(false)
  }

  let content

  if (!nextStep) {
    content = (
      <form className={Style.mainForm} onSubmit={formHandler}>
        <div
          className={
            (submit === true && !inputState.oldPassword.valid) || error
              ? `${Style.invalidInputSpan} ${Style.inputSpan}`
              : Style.inputSpan
          }
        >
          <span className={Style.inputText}>Стара парола</span>
          <div
            className={`${Style.inputiconWrapper} ${Style.inputiconWrapperPass}`}
          >
            <PassIcon />
          </div>
          <div className={`${Style.inputiconWrapperTwo} `}>
            <Button
              buttonHandler={showPassInputOneHandler}
              style={Style.visBtn}
              type="button"
            >
              {!showPassOne && <VisIcon />}
              {showPassOne && <VisIconOff />}
            </Button>
          </div>
          <Input
            focusHandler={resolveInputServerError}
            inputHandler={inputHandler}
            data="oldPassword"
            type={showPassOne ? "text" : "password"}
            inputValue={inputState.oldPassword.val}
          />
          {submit && !inputState.oldPassword.valid && (
            <div className={Style.invalidTextWrapper}>
              <Icon />
              <p className={Style.invalidText}>{`Невалидна парола`}</p>
            </div>
          )}
          {error && (
            <div className={Style.invalidTextWrapper}>
              <Icon />
              <p className={Style.invalidText}>{`Грешна парола`}</p>
            </div>
          )}
        </div>

        <div
          className={
            submit === true && !inputState.password.valid
              ? `${Style.invalidInputSpan} ${Style.inputSpan}`
              : Style.inputSpan
          }
        >
          <span className={Style.inputText}>Нова Парола</span>
          <div
            className={`${Style.inputiconWrapper} ${Style.inputiconWrapperPass}`}
          >
            <PassIcon />
          </div>
          <div className={`${Style.inputiconWrapperTwo} `}>
            <Button
              buttonHandler={showPassInputTwoHandler}
              style={Style.visBtn}
              type="button"
            >
              {!showPassTwo && <VisIcon />}
              {showPassTwo && <VisIconOff />}
            </Button>
          </div>
          <Input
            // focusHandler={resolveInputServerError}
            inputHandler={inputHandler}
            data="newPassword"
            type={showPassTwo ? "text" : "password"}
            inputValue={inputState.password.val}
          />
          {submit && !inputState.password.valid && (
            <div className={Style.invalidTextWrapper}>
              <Icon />
              <p className={Style.invalidText}>{`Невалидна парола`}</p>
            </div>
          )}
          {/* {error && (
          <div className={Style.invalidTextWrapper}>
            <Icon />
            <p className={Style.invalidText}>{`Грешна парола`}</p>
          </div>
        )} */}
        </div>
        <div
          className={
            submit === true && !inputState.comparePassword.valid
              ? `${Style.invalidInputSpan} ${Style.inputSpan}`
              : Style.inputSpan
          }
        >
          <span className={Style.inputText}>Потвърди Паролата</span>
          <div
            className={`${Style.inputiconWrapper} ${Style.inputiconWrapperPass}`}
          >
            <PassIcon />
          </div>
          <div className={`${Style.inputiconWrapperTwo} `}>
            <Button
              buttonHandler={showPassInputThreeHandler}
              style={Style.visBtn}
              type="button"
            >
              {!showPassThree && <VisIcon />}
              {showPassThree && <VisIconOff />}
            </Button>
          </div>
          <Input
            // focusHandler={resolveInputServerError}
            inputHandler={inputHandler}
            data="confirmPassword"
            type={showPassThree ? "text" : "password"}
            inputValue={inputState.comparePassword.val}
          />
          {submit && !inputState.comparePassword.valid && (
            <div className={Style.invalidTextWrapper}>
              <Icon />
              <p className={Style.invalidText}>{`Паролите не съвпадат`}</p>
            </div>
          )}
          {/* {error && (
          <div className={Style.invalidTextWrapper}>
            <Icon />
            <p className={Style.invalidText}>{`Грешна парола`}</p>
          </div>
        )} */}
        </div>
        <Button style={Style.btn}>СМЕНИ</Button>
      </form>
    )
  } else {
    content = <h4 className={Style.passwordChangedText}>ПАРОЛАТА Е СМЕНЕНА</h4>
  }

  return (
    <section className={Style.changePassWrapper}>
      {!loading && (
        <React.Fragment>
          <div className={Style.changePassHeadingWrapper}>
            <h3>Смяна на паролата</h3>
            <Button buttonHandler={closeHandler}>
              <CloseIcon />
            </Button>
          </div>

          {content}
        </React.Fragment>
      )}
      {loading && (
        <Loader
          style={Style.changePassLoader}
          animationStyle={Style.changePassLoaderAnimation}
        />
      )}
    </section>
  )
}

export default ChangePass
